module.exports = __webpack_public_path__ + "static/jing3-5cac6727b5f12b6d4ba03d1442157e28.jpg";